import r from "./index318.js";
import { resolveComponent as o, createBlock as n, openBlock as s } from "vue";
import i from "./index231.js";
function p(e, a, c, _, m, l) {
  const t = o("ms-ad-place");
  return s(), n(t, {
    placementId: "pa",
    height: e.getMaxHeight(),
    isInDisturber: e.isInDisturber
  }, null, 8, ["height", "isInDisturber"]);
}
const h = /* @__PURE__ */ i(r, [["render", p]]);
export {
  h as default
};
